module.exports = __webpack_public_path__ + "img/rank_more04.3f6f7723.png";